export const UI_ACTIONS = {
    MODAL_OPEN: "ui-modal-open",
    MODAL_CLOSE: "ui-modal-close"
};
export const openModal = (info) => (dispatch) => {
    dispatch({
        type: UI_ACTIONS.MODAL_OPEN,
        payload: {
            triggerId: info.triggerId,
            modalId: info.modalId
        }
    });
};
export const closeModal = (info) => (dispatch) => {
    dispatch({
        type: UI_ACTIONS.MODAL_CLOSE,
        payload: {
            triggerId: info.triggerId,
            modalId: info.modalId
        }
    });
};



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/ui/uiActions.ts